import Input from '@blocks/Input'
import React, { useState } from 'react'
import styled from 'styled-components'
import { useTableContext } from '../context'

const CurrentPage = () => {
    const { state, pageCount, gotoPage } = useTableContext()

    if (state?.pageIndex === undefined || pageCount === undefined || !gotoPage) throw "Error: element `CurrentPage` was rendered outside of the table context provider."

    const [inputWidth, setInputWidth] = useState<string>((state.pageIndex + 1).toString().length + "ch")

    return <Input
        id="table-page"
        name="table-page"
        type="number" 
        label={`Pages: ${Math.max(pageCount, 1)}. Current:`}
        format="ch"
        value={state.pageIndex + 1} 
        style={{ width: inputWidth }}
        inline
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = parseInt(e.target.value)
            let page = newValue ? newValue : 1
            page = page > pageCount ? pageCount : page
            if (page == state.pageIndex + 1) return
            gotoPage(page - 1)
            setInputWidth(page.toString().length + "ch")
        }}
    />
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`

export default React.memo(CurrentPage)